import React from 'react';

import { inToPx, pageSeparationPx } from '@aline/common';
import { Typography } from '@mui/material';
import { AlineLogoIconNoBackground } from 'src/components/icons/AlineLogoIconNoBackground';
import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

const pulsingText = keyframes`
  0% { opacity: 1 }
  50% { opacity: 0.5 }
  100% { opacity: 1 }
`;

const useStyles = makeStyles()(theme => ({
  animate: {
    animation: `${pulsingText} 2s infinite`,
    color: theme.appColors.rule,
    fontSize: 32,
    fontWeight: 600,
  },
  loadingPage: {
    alignItems: 'center',
    backgroundColor: 'white',
    boxShadow: theme.appShadows.page,
    boxSizing: 'border-box',
    cursor: 'text',
    display: 'flex',
    flexDirection: 'column',
    height: inToPx(11),
    justifyContent: 'center',
    margin: `${pageSeparationPx}px auto ${pageSeparationPx}px auto`,
    userSelect: 'none',
    width: inToPx(8.5),
  },
  logo: {
    height: 100,
    width: 100,
  },
  surface: {
    backgroundColor: theme.appColors.defaultFieldBackground,
    boxSizing: 'border-box',
    height: '100%',
    overflow: 'auto',
    width: '100%',
  },
}));

export function EditorLoadingPage(): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.surface}>
      <div className={classes.loadingPage}>
        <AlineLogoIconNoBackground className={classes.logo} />
        <Typography className={classes.animate}>ALINE EDITOR</Typography>
      </div>
    </div>
  );
}
